import React from "react";
import { Link } from "react-router-dom";
import { Button, Badge, Text, useColorModeValue } from "@chakra-ui/react";
import { ImLocation } from "react-icons/im";
import moment from "moment";
import { EditIcon } from "@chakra-ui/icons";

const ListingItemMobile = ({ id, car, deleteListing, editListing }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const shadowColor = useColorModeValue(
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)"
  );

  return (
    <div
      className={`relative bg-${cardBg} w-[95%] rounded-2xl my-6 overflow-hidden border border-opacity-20 border-gray-300 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl`}
      style={{ boxShadow: shadowColor }}
    >
      {/* Image with hover effect */}
      <div className="relative group overflow-hidden h-48">
        <div className="bg-gray-400">
        <img
          src={car.carImages[0]}
          alt={car.modelName}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
         </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        
        {/* Badges */}
        <div className="absolute top-3 right-3 flex space-x-2">
          {car.offer && (
            <Badge 
              colorScheme="red" 
              className="transform hover:scale-110 transition-transform shadow-md"
            >
              Offer
            </Badge>
          )}
          {car.featured && (
            <Badge 
              colorScheme="blue" 
              className="transform hover:scale-110 transition-transform shadow-md"
            >
              Featured
            </Badge>
          )}
        </div>
      </div>

      <div className="p-4 flex flex-col">
        <div className="flex justify-between items-start mb-2">
          <div>
            <Text fontSize="xl" fontWeight="bold" className="text-gray-900">
              {car.modelName} {car.modelYear}
            </Text>
            <Text fontSize="md" className="text-blue-600">
              {car.manufacturer}
            </Text>
          </div>
          {car?.timestamp && (
            <Badge colorScheme="green" fontSize="xs">
              {moment(car?.timestamp?.toDate()).fromNow()}
            </Badge>
          )}
        </div>

        <div className="flex items-center text-gray-600 mb-3">
          <ImLocation className="inline mr-1 text-blue-500" size={14} />
          <Text fontSize="sm">{car.city}</Text>
        </div>

        <div className="grid grid-cols-2 gap-2 mb-4">
          <div className="bg-blue-50 p-2 rounded-lg">
            <Text fontSize="sm" className="text-gray-700">
              <span className="font-semibold">Mileage:</span> {car.mileage} Km
            </Text>
          </div>
          <div className="bg-blue-50 p-2 rounded-lg">
            <Text fontSize="sm" className="text-gray-700">
              <span className="font-semibold">Color:</span> {car.color}
            </Text>
          </div>
        </div>

        <div className="flex justify-between items-center mb-4">
          <Text fontSize="lg" fontWeight="bold" className="text-blue-700">
            PKR {car.offer ? car.discountedPrice : car.price}
            {car.type === "rent" && (
              <span className="text-sm text-gray-500 ml-1">/ride</span>
            )}
          </Text>
          {car.offer && (
            <Text fontSize="sm" className="line-through text-gray-500">
              PKR {car.price}
            </Text>
          )}
        </div>

        <Link to={`/category/${car.type}/${id}`} className="w-full">
          <Button
            width="full"
            className="transition-all duration-300 transform hover:scale-[1.02] hover:shadow-md"
            bgGradient="linear(to-r, blue.500, blue.600)"
            color="white"
            _hover={{
              bgGradient: "linear(to-r, blue.600, blue.700)",
              transform: "translateY(-1px)",
              boxShadow: "md",
            }}
            _active={{
              bgGradient: "linear(to-r, blue.700, blue.800)",
            }}
            size="md"
            borderRadius="lg"
            boxShadow="sm"
          >
            View Details
          </Button>
        </Link>

        {(editListing || deleteListing) && (
          <div className="flex space-x-2 mt-3">
            {editListing && (
              <Link to={`/edit-listing/${id}`} className="flex-1">
                <Button
                  width="full"
                  leftIcon={<EditIcon boxSize={4} />}
                  colorScheme="blue"
                  variant="outline"
                  size="sm"
                  borderRadius="lg"
                  className="transition-all hover:shadow-sm"
                >
                  Edit
                </Button>
              </Link>
            )}
            {deleteListing && (
              <Button
                width="full"
                colorScheme="red"
                variant="outline"
                size="sm"
                borderRadius="lg"
                className="transition-all hover:shadow-sm"
                onClick={() => deleteListing(car.id)}
              >
                Delete
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListingItemMobile;